/**
 * 자산 타입의 단수형과 복수형 매핑
 */
export const assetTypePluralMap: Record<string, string> = {
  table: 'tables',
  topic: 'topics',
  dashboard: 'dashboards',
  databaseSchema: 'databaseSchemas',
  glossaryTerm: 'glossaryTerms',
  container: 'containers',
  database: 'databases',
  pipeline: 'pipelines',
  mlmodel: 'mlmodels',
  query: 'queries',
  chart: 'charts',
  report: 'reports',
  metric: 'metrics',
  glossary: 'glossaries',
  tag: 'tags',
  policy: 'policies',
  location: 'locations',
  classification: 'classifications',
};

/**
 * 자산 타입의 복수형을 반환
 * @param type - 자산 타입 문자열
 * @returns 복수형 문자열
 */
export const getAssetTypePlural = (type: string): string => {
  return assetTypePluralMap[type] || `${type}s`;
};

/**
 * run_ 접두사가 붙은 엔티티 타입을 기본 타입으로 정규화
 * @param type - 엔티티 타입 문자열
 * @returns 정규화된 타입 문자열
 */
export const normalizeEntityType = (type: string): string => {
  if (type === 'run_feature_set') return 'feature_set';
  if (type === 'run_dataset') return 'dataset';
  if (type === 'run_parameter_set') return 'parameter_set';
  if (type === 'run_artifact') return 'artifact';
  return type;
};
